const udhrPreamble = `Gan mai cydnabod urddas cynhenid a hawliau cydradd a phriod holl aelodau’r teulu dynol yw sylfaen rhyddid, cyfiawnder a heddwch yn y byd,

Gan i anwybyddu a dirmygu hawliau dynol arwain at weithredoedd barbaraidd a dreisiodd gydwybod dynolryw, a bod dyfodiad byd lle y gall pob unigolyn fwynhau rhyddid i siarad a chredu a rhyddid rhag ofn ac angau wedi ei gyhoeddi yn ddyhead uchaf y bobl gyffredin,

Gan fod yn rhaid amddiffyn hawliau dynol a rheolaeth cyfraith, os nad yw pob unigolyn dan orfod yn y pendraw i wrthryfela yn erbyn gormes a thrais,

Gan fod yn rhaid hyrwyddo cysylltiadau cyfeillgar rhwng Cenhedloedd,

Gan fod pobloedd y Cenhedloedd Unedig yn y Siarter wedi ail ddatgan ffydd mewn hawliau sylfaenol yr unigolyn, mewn urddas a gwerth y person dynol ac mewn hawliau cydradd

gwr a gwragedd, ac wedi penderfynu hyrwyddo cynnydd cymdeithasol a safonau byw gwell mewn rhyddid helaethach,

Gan fod y Gwladwriaethau sy'n Aelodau wedi ymrwymo, mewn cydweithrediad â'r Cenhedloedd Unedig, i sicrhau hyrwyddo parch cyffredinol i hawliau dynol a'r rhyddfreintiau sylfaenol, a'u cadw,

Gan fod deall yr hawliau a'r rhyddfreintiau hyn gan bawb o'r pwys mwyaf i lwyr sylweddoli'r ymrwymiad hwn,

Felly, y mae'r

Cynulliad Cyffredinol

yn awr yn cyhoeddi'r

Datganiad Cyffredinol hwn o Hawliau Dynol

yn ddelfryd cyffredin i'r holl bobloedd a'r holl genhedloedd ymgyrraedd ato, fel y bo i bob person ac i bob offeryn cymdeithasol, gan ddal y Datganiad hwn mewn cof yn wastad, ymdrechu trwy ddysgu a hyfforddi i sicrhau parch i'r hawliau a'r rhyddfreintiau hyn, a thrwy ffyrdd blaengar, cenedlaethol a chydgenedlaethol, i sicrhau eu cydnabod a'u cadw yn gyffredinol ac yn effeithiol, ymysg pobloedd y Gwladwriaethau sy'n Aelodau eu hunain yn ogystal ag ymysg pobloedd y tiriogaethau sydd dan eu rheolaeth.
`;
const udhr1 = `Genir pawb yn rhydd ac yn gydradd â'i gilydd mewn urddas a hawliau. Fe'u cynysgaeddir â rheswm a chydwybod, a dylai pawb ymddwyn y naill at y llall mewn ysbryd cymodlon.`;
module.exports = {
  name: 'Welsh',
  udhrPreamble,
  udhr1,
  lang: 'cy',
};
